import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Shield, Database, Lock, Settings } from 'lucide-react';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Back button */}
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
          data-testid="privacy-back-btn"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <Shield className="h-6 w-6 text-blue-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          </div>
          <div className="w-16 h-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full mb-6"></div>
          
          <p className="text-lg text-gray-700 leading-relaxed">
            We respect your privacy.
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">
          {/* Data Collection */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Database className="h-5 w-5 text-purple-600" />
              <h2 className="text-xl font-semibold text-gray-900">Information We Collect</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              POLIVOX collects basic user information such as name, email, and activity within the 
              platform to provide and improve our services.
            </p>
          </div>

          {/* Data Usage */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Lock className="h-5 w-5 text-green-600" />
              <h2 className="text-xl font-semibold text-gray-900">How We Use Your Data</h2>
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              We do not sell your personal data to third parties. Your data is used to:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                <span>Provide platform features</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                <span>Improve user experience</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                <span>Ensure security and prevent misuse</span>
              </li>
            </ul>
          </div>

          {/* Privacy Controls */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <Settings className="h-5 w-5 text-amber-600" />
              <h2 className="text-xl font-semibold text-gray-900">Your Privacy Controls</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              You can control your privacy settings within your profile. Manage what information 
              is visible to others and how your data is used.
            </p>
          </div>

          {/* Agreement */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-blue-100">
            <p className="text-gray-700 text-center">
              By using POLIVOX, you agree to this privacy policy.
            </p>
          </div>
        </div>

        {/* Last updated */}
        <div className="text-center text-gray-400 text-sm mt-8">
          <p>Last updated: March 2026</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
